import { render, staticRenderFns } from "./EditPhysicalDoc.vue?vue&type=template&id=03414f62&scoped=true&"
import script from "./EditPhysicalDoc.vue?vue&type=script&lang=js&"
export * from "./EditPhysicalDoc.vue?vue&type=script&lang=js&"
import style0 from "./EditPhysicalDoc.vue?vue&type=style&index=0&id=03414f62&lang=scss&scoped=true&"
import style1 from "./EditPhysicalDoc.vue?vue&type=style&index=1&id=03414f62&scoped=true&lang=css&"
import style2 from "../../styles/physical-doc-dialog.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03414f62",
  null
  
)

export default component.exports